import React, { useState, useEffect } from "react";

import Buttons from "../../../../components/ui/button/Buttons";

import MolGrid, { Column } from "@moltech/molui/molgrid";
import "./ProductSalesSearch.scss"
import Input from "../../../../components/finalForms/ui/inputs/input/Input";
import { useLazyProductSalesSearchQuery } from "../../../../app/services/productSalesAPI";
import ToastService from "../../../../services/toastService/ToastService";

const ProductSalesSearch = () => {

    const [filters, setFilters] = useState({
        invoiceNo: "",
        poNo: "",
        description2: ""
    });
    const [productSalesData, setProductSalesData] = useState([])

    const [getProductSaleSearchData, {
        isFetching: isProductSalesSearchFetching,
        isLoading: isProductSalesSearchLoading,
        isSuccess: isProductSalesSearchSuccess,

        data: productSalesSearchData
    }] = useLazyProductSalesSearchQuery();

    const handleSearchChange = (field, value) => {
        setFilters((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    useEffect(() => {
        if (!isProductSalesSearchFetching, isProductSalesSearchSuccess && productSalesSearchData) {
            if (productSalesSearchData) {
                setProductSalesData(productSalesSearchData)
            }
        }
    }, [isProductSalesSearchFetching, isProductSalesSearchSuccess, productSalesSearchData])

    const handleSearchClick = () => {
        const isAllEmpty =
            !filters.invoiceNo?.trim() &&
            !filters.poNo?.trim() &&
            !filters.description2?.trim();

        if (isAllEmpty) {
            ToastService.warning("Please enter at least one search criteria.");
            return;
        }
        const req = {
            psInvoiceNumber: filters.invoiceNo,
            psPONumber: filters.poNo,
            psDescription2: filters.description2
        }
        getProductSaleSearchData(req)
    };

    const handleClearClick = () => {
        setFilters({
            invoiceNo: "",
            poNo: "",
            description2: ""
        });
        setProductSalesData([])
    };

    const handleRowDoubleClick = (event) => {
        const { lClientKey, lDepartmentKey, lProductSaleKey } = event.data;
        window.open(
            `/ProductSale?client=${lClientKey}&department=${lDepartmentKey}&sales=${lProductSaleKey}`,
            "_blank"
        );

    };


    /* ------------------ UI ------------------ */

    return (
        <div className="product-sale-search">

            {/* Search Section */}
            <div className="product-sale-search-header">

                <div className="product-sale-search-input-row">
                    <div className="product-sale-search-field">
                        <label>Invoice #</label>
                        <Input
                            value={filters?.invoiceNo}
                            placeholder="Search by Invoice Number"
                            onChange={(e) =>
                                handleSearchChange("invoiceNo", e)
                            }
                        />
                    </div>

                    <div className="product-sale-search-field">
                        <label>PO #</label>
                        <Input
                            value={filters?.poNo}
                            placeholder="Search by PO Number"
                            onChange={(e) =>
                                handleSearchChange("poNo", e)
                            }
                        />
                    </div>

                    <div className="product-sale-search-field">
                        <label>Description 2</label>
                        <Input
                            value={filters?.description2}
                            placeholder="Search by Description 2"
                            onChange={(e) =>
                                handleSearchChange("description2", e)
                            }
                        />
                    </div>
                </div>

                <div className="product-sale-search-button-row">
                    <Buttons
                        buttonText="Search"
                        onClick={handleSearchClick}
                        buttonTypeClassName="btn blue-btn"
                    />
                    <Buttons
                        buttonText="Clear"
                        onClick={handleClearClick}
                        buttonTypeClassName="btn secondary-btn"
                    />
                </div>
            </div>

            {/* Grid */}
            <div className="product-sale-search-grid">
                <MolGrid
                    paginator={false}
                    value={productSalesData}
                    scrollable
                    scrollHeight="flex"
                    filterDisplay="row"
                    Loading={isProductSalesSearchLoading}
                    onRowDoubleClick={handleRowDoubleClick}
                >
                    <Column field="sClientName1" header="Client" />
                    <Column field="sDepartmentName" header="Department" />
                    <Column field="sInvoiceNumber" header="Invoice #" />
                    <Column field="sPurchaseOrder" header="PO #" />

                    <Column field="sSizeDescription2" header="Description 2" />

                    <Column field="dtOrderDate" header="Order Date" sortable={false} colType="datetime" format="mm/dd/yyyy" />
                </MolGrid>
            </div>
        </div>
    );
};

export default ProductSalesSearch;